import { KnobModule } from 'ng2-knob';
import { NouisliderModule } from 'ng2-nouislider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { ToolPage } from './tool';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DynamicModule } from 'ng-dynamic-component';
import { Material } from './material/material';
import { Endmill } from './endmill/endmill';
import { Machine } from './machine/machine';
import { Operation } from './operation/operation';
import { Parameters } from './parameters/parameters';
import { Recommendations } from './recommendations/recommendations';
import { Summary } from './summary/summary';
import { Start } from './start/start';
import { Knob } from 'src/service/ng-knob2';
import { ToolPathSelectorDialog } from './operation/toolPathSelector/toolPathSelector';

const toolSections = [Start, Endmill, Material, Operation, Machine, Parameters, Recommendations, Summary];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MatAutocompleteModule,
    MatCardModule,
    MatDialogModule,
    MatGridListModule,
    MatInputModule,
    MatSelectModule,
    MatSliderModule,
    MatTabsModule,
    KnobModule,
    NouisliderModule,
    MatMenuModule,
    DynamicModule
  ],
  declarations: [ToolPage, ...toolSections, ToolPathSelectorDialog, Knob],
  entryComponents: [ToolPathSelectorDialog]
})
export class ToolPageModule {}
